import moment from "moment"

// 本日
function getTodayRange() {
	const start = moment().format('YYYY-MM-DD');
	const end = moment().format('YYYY-MM-DD');
	return {
		start,
		end
	};
}

// 昨天
function getYesterdayRange() {
	const start = moment().subtract(1, 'days').format('YYYY-MM-DD');
	const end = moment().subtract(1, 'days').format('YYYY-MM-DD');
	return {
		start,
		end
	};
}

// 本周
function getThisWeekRange() {
	const start = moment().startOf('week').format('YYYY-MM-DD');
	const end = moment().endOf('week').format('YYYY-MM-DD');
	return {
		start,
		end
	};
}
// 本月
function getThisMonthRange() {
	const start = moment().startOf('month').format('YYYY-MM-DD');
	const end = moment().endOf('month').format('YYYY-MM-DD');
	return {
		start,
		end
	};
}

// 本季
function getThisQuarterRange() {
	const start = moment().startOf('quarter').format('YYYY-MM-DD');
	const end = moment().endOf('quarter').format('YYYY-MM-DD');
	return {
		start,
		end
	};
}

// 本年
function getThisYearRange() {
	const start = moment().startOf('year').format('YYYY-MM-DD');
	const end = moment().endOf('year').format('YYYY-MM-DD');
	return {
		start,
		end
	};
}

export {
	getTodayRange,
	getYesterdayRange,
	getThisWeekRange,
	getThisMonthRange,
	getThisQuarterRange,
	getThisYearRange
};